// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3Mksq","footer":"ModalFilter_footer__1KhJV"};